import { useState } from 'react'

export type SortOrder = 'asc' | 'desc' | false

export function useSortTable<T>() {
  const [sort, setSort] = useState<T | ''>('')
  const [order, setOrder] = useState<SortOrder>(false)

  const toggleSortOrder = (column: T) => {
    if (sort !== column) {
      setSort(column)
      setOrder('asc')
    } else {
      setOrder((prev) =>
        prev === 'asc' ? 'desc' : prev === 'desc' ? false : 'asc',
      )
    }
  }

  const sortQueryString = sort && order ? `&sort=${sort}&order=${order}` : ''

  function getSortOrder(column: T) {
    if (sort === column) return order

    // retorna falso para não renderizar as arrows
    return false
  }

  return { getSortOrder, toggleSortOrder, sortQueryString }
}
